/**
 * 配置站点地图路由
 * @priority 1
 * @changefreq daily
 */

//* Vue Router
import type { RouteRecordRaw } from "vue-router";

export default [
    {
        name: "Home",
        path: "",
        meta: { name: "Home", type: "Home Page" },
        components: {
            web: () => import("@/views/main/web/index.vue"),
            mobile: () => import("@/views/main/mobile/index.vue"),
        },
    },
] as RouteRecordRaw[];
